import * as Yup from 'yup';
import { NUMBER_REGEX } from '../../../constants';

export const prospectApprovalRequestFormValidationSchema = Yup.object({
  agentEvaluation: Yup
    .string()
    .matches(NUMBER_REGEX, 'Il campo deve contenere un valore numerico intero. Es. 210000')
    .required('Il campo è obbligatorio'),
});
